/* Product recommendations section 
--------------------------------------*/

// import Swiper from "../vendors/swiper.js";
// alert("555")
class ProductRecommendations {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.productRecommendations();
  }
  
  productRecommendationSlider = (sliderClass) => {
    const recommendationSwiper = new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      shortSwipes: true,
      shortSwipesRatio: 0,
      speed: 1000,
      spaceBetween: 20,
    
        watchSlidesProgress: true,
        
      autoplay: {
        delay: 2000000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.40,
          resizeReInit: true,
          grabCursor: true,
          freeMode: true,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2.25,
          resizeReInit: true,
          grabCursor: true,
          freeMode: true,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  productRecommendationSingleSlider = (sliderClass) => {
    /* Product recommendations section slider */
    const recommendationSwiper = new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      shortSwipes: true,
      shortSwipesRatio: 0,
      speed: 1000,
      spaceBetween: 20,
      autoplay: {
        delay: 2000000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          resizeReInit: true,
          grabCursor: true,
          freeMode: true,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2,
          resizeReInit: true,
          grabCursor: true,
          freeMode: true,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  
  productRecommendations = () => {
    let productRecommendationsSection = this.parent;
    let mainRecommendationSection = qs('.product-recommendation-section-js');
    let mobileSlider = qs('.mobile-slider-js', mainRecommendationSection);
    if (productRecommendationsSection.dataset.blockProduct == 'active') {
      if (window.innerWidth < 768) {
        if (mobileSlider) {
          if (qs('.mobile-one-column-js', mainRecommendationSection)) {
            this.productRecommendationSingleSlider(".mobile-one-column-js");
          } else {
            this.productRecommendationSlider('.recommendation-slider-js');
          }
          simply.productCardGlobal(qsa('.product-main-js'));
        }
      } else {
        this.productRecommendationSlider('.recommendation-slider-js');
        simply.productCardGlobal(qsa('.product-main-js'));
      }
      if (mainRecommendationSection) {
        mainRecommendationSection.classList.remove('hidden');
      }
      return;
    }
    let url = productRecommendationsSection.dataset.url;
    fetch(url)
    .then(response => response.text())
    .then(text => {
      let html = document.createElement('div');
      html.innerHTML = text;
      let recommendations = qs('.product-recommendations-js', html);
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        if (window.innerWidth < 768) {
          if (mobileSlider) {
            this.productRecommendationSlider('.recommendation-slider-js');
            this.productRecommendationSingleSlider(".mobile-one-column-js");
            simply.productCardGlobal(qsa('.product-main-js'));
          }
        } else {
          this.productRecommendationSlider('.recommendation-slider-js');
          simply.productCardGlobal(qsa('.product-main-js'));
        }
        if (mainRecommendationSection) {
          mainRecommendationSection.classList.remove('hidden');
        }
      }
    })
    .catch(e => {
      console.error(e);
    });
  }
}

new ProductRecommendations(qs('.product-recommendation-section-js .product-recommendations-js'));
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new ProductRecommendations(qs('.product-recommendation-section-js .product-recommendations-js'));
  });
}